import { render, staticRenderFns } from "./record_order.vue?vue&type=template&id=50aced4e&"
import script from "./record_order.vue?vue&type=script&lang=js&"
export * from "./record_order.vue?vue&type=script&lang=js&"
import style0 from "./record_order.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports